import { isUniqueViolation } from 'modules/core/supabase/errors';

/**
 * The DB rule behind the conflict: `media_manager_templates.alias_tournament_name`
 * ("<tournament_id|default>_<trimmed, lower-cased name>") is UNIQUE, so a template
 * name can occur once per tournament and a preset name once globally.
 * See src/migrations/20260507_media_manager.sql.
 */
export const TEMPLATE_NAME_UNIQUE_CONSTRAINT = 'media_manager_templates_alias_tournament_name_unique';

/** Message shown when the DB rejects a name — same wording as the client-side check. */
export const TEMPLATE_NAME_CONFLICT_MESSAGE = 'Такое название уже существует, придумайте новое';

/** True when a write failed because the name is already taken in that scope. */
export function isTemplateNameConflict(error: unknown): boolean {
  return isUniqueViolation(error, TEMPLATE_NAME_UNIQUE_CONSTRAINT);
}

/**
 * Names are compared case- and whitespace-insensitively, matching the generated
 * alias column — otherwise the client would accept a name the DB then rejects.
 */
export function normalizeTemplateName(name: string): string {
  return name.trim().toLowerCase();
}
